import React, { useState, useEffect } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    Box
} from '@mui/material';
import { Save, X } from 'react-feather';

const ProblemTypeDialog = ({ open, problemType, onClose, onSave }) => {
    const [formData, setFormData] = useState({
        id: null,
        problem_type: ''
    });

    const [errors, setErrors] = useState({});

    // Initialize form data when problemType changes
    useEffect(() => {
        if (problemType) {
            setFormData({
                id: problemType.id,
                problem_type: problemType.problem_type || ''
            });
        } else {
            setFormData({
                id: null,
                problem_type: ''
            });
        }
        setErrors({});
    }, [problemType]);

    // Handle input change
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });

        // Clear error for the field
        if (errors[name]) {
            setErrors({
                ...errors,
                [name]: null
            });
        }
    };

    // Validate form
    const validateForm = () => {
        const newErrors = {};

        if (!formData.problem_type.trim()) {
            newErrors.problem_type = 'Problem type name is required';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // Handle save
    const handleSave = () => {
        if (validateForm()) {
            onSave(formData, !problemType);
        }
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: '10px',
                    overflow: 'hidden'
                }
            }}
        >
            <DialogTitle sx={{ py: 2, px: 3, bgcolor: '#F9FAFB' }}>
                {problemType ? 'Edit Problem Type' : 'Add New Problem Type'}
            </DialogTitle>

            <DialogContent sx={{ p: 3 }}>
                <Box sx={{ mb: 2 }}>
                    <TextField
                        fullWidth
                        label="Problem Type Name *"
                        name="problem_type"
                        value={formData.problem_type}
                        onChange={handleInputChange}
                        error={!!errors.problem_type}
                        helperText={errors.problem_type || 'Examples: Electrical, Plumbing, Carpentry, HVAC'}
                        autoFocus
                    />
                </Box>
            </DialogContent>

            <DialogActions sx={{ px: 3, py: 2, bgcolor: '#F9FAFB' }}>
                <Button
                    onClick={onClose}
                    variant="outlined"
                    startIcon={<X size={16} />}
                    sx={{ borderRadius: '8px' }}
                >
                    Cancel
                </Button>
                <Button
                    onClick={handleSave}
                    variant="contained"
                    color="primary"
                    startIcon={<Save size={16} />}
                    sx={{ borderRadius: '8px' }}
                >
                    {problemType ? 'Update Problem Type' : 'Add Problem Type'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ProblemTypeDialog;